import { ADD_NEW_ROW, DELETE_ROW, EXAMSERIES_MONTH_HANDLECHANGE, 
  EXAMSERIES_YEAR_HANDLECHANGE, EXAM_HANDLECHANGE, 
  EXAMCENTER_HANDLECHANGE, CANDIDATENUMBER_HANDLECHANGE,
  UPDATE_EMPTY_FLAG_EXAM, UPDATE_DUPLICATE_FLAG_EXAM, GET_EXAM_SERIES_SUCCESS,
  GET_EXAM_SERIES_ERROR, GET_EXAM_CENTRE_LIST_SUCCESS, GET_EXAM_CENTRE_LIST_ERROR,
  RESET_EXAM_DETAILS
} from "../actionTypes";

import { v4 as uuidv4 } from 'uuid';

const initialState = {
    examDetailsList: [
        {
          id:uuidv4(),
          examSeries:{
            month:"",
            year:""
          } ,
          exam: "GCE AS & A Level",
          examCenter: "",
          examCenterID: "",
          candidateNumber: "",
          duplicateValueFlag: "false",
          emptyValueFlag: "false"
        }
    ],
    examSeriesApiValues: [],
    examApiValues:[
      {
        "name" : "AS & A Level exams and/or AICE Diploma"
      }
    ],
    examCenterApivalues:[]

};

const examDetailsInfo = (state = initialState, action) => {
  const newState = {...state}
  switch (action.type) {
    case ADD_NEW_ROW :
        const newSeries = {
          id:uuidv4(),
          examSeries:{
            month:"",
            year:""
          } ,
          exam: "GCE AS & A Level",
          examCenter: "",
          examCenterID: "",
          candidateNumber: "",
          duplicateValueFlag: "false",
          emptyValueFlag: "false"
        }
      return{
        ...newState,
        examDetailsList : newState.examDetailsList.concat(newSeries)
      }

    case DELETE_ROW:
      return{
        ...newState, 
        examDetailsList:newState.examDetailsList.filter((item, index) => item.id !== action.id)
      }

    case EXAMSERIES_MONTH_HANDLECHANGE:
      return { 
        ...newState, 
        examDetailsList: newState.examDetailsList.map(
            (item, i) => item.id === action.payload.index ? {...item, examSeries:{...item.examSeries, month:action.payload.value}}
                                    : item
        )
     }

    case EXAMSERIES_YEAR_HANDLECHANGE:
      return { 
        ...newState, 
        examDetailsList: newState.examDetailsList.map(
            (item, i) => item.id === action.payload.index ? {...item, examSeries:{...item.examSeries, year:action.payload.value}}
                                    : item
        )
     }

    case EXAM_HANDLECHANGE:
      return { 
        ...newState, 
        examDetailsList: newState.examDetailsList.map(
            (item, i) => item.id === action.payload.index ? {...item, exam: action.payload.value}
                                    : item
        )
     }

    case EXAMCENTER_HANDLECHANGE:
      return { 
        ...newState, 
        examDetailsList: newState.examDetailsList.map(
            (item, i) => item.id === action.payload.index ? {...item,
               examCenter: action.payload.value.dataValue,
               examCenterID: action.payload.value.dataID
            }
                                    : item
        )
     }
     
     case CANDIDATENUMBER_HANDLECHANGE:
      const regEx = /^[0-9\s]*$/;
      return { 
        ...newState, 
        examDetailsList: newState.examDetailsList.map(
            (item, i) => ( item.id === action.payload.index && regEx.test(action.payload.value)) ? {...item, candidateNumber: action.payload.value}
                                    : item
        )
     }

     case UPDATE_EMPTY_FLAG_EXAM:
     return {
         ...newState,
         examDetailsList: newState.examDetailsList.map(
             (item, i) => item.id === action.payload.index ? { ...item, emptyValueFlag: action.payload.value }
                 : item
         )
     }
     case UPDATE_DUPLICATE_FLAG_EXAM:
     return {
         ...newState,
         examDetailsList: newState.examDetailsList.map(
             (item, i) => item.id === action.payload.index ? { ...item, duplicateValueFlag: action.payload.value }
                 : item
         )
     }
     case GET_EXAM_SERIES_SUCCESS:
       return {
        ...newState,
        examSeriesApiValues: action.payload.sessions
       }
      case GET_EXAM_SERIES_ERROR:
       return  {
        ...newState,
        examSeriesApiValues: []
        }
    case GET_EXAM_CENTRE_LIST_SUCCESS:
      return {
        ...newState,
        examCenterApivalues: action.payload.centers
      }
    case GET_EXAM_CENTRE_LIST_ERROR:
    return  {
      ...newState,
      examCenterApivalues: []
      }
    case RESET_EXAM_DETAILS:
      return {
        ...newState,
        examDetailsList: [{...initialState.examDetailsList[0]}]
      }
    default: {
      return state;
    }
  }
};

export default examDetailsInfo;